import { dew as _createTransportDew } from "./createTransport.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.custom = void 0;
  const createTransport_js_1 = _createTransportDew();
  function custom(provider, config = {}) {
    const {
      key = "custom",
      name = "Custom Provider",
      retryDelay
    } = config;
    return ({
      retryCount: defaultRetryCount
    }) => (0, createTransport_js_1.createTransport)({
      key,
      name,
      request: provider.request.bind(provider),
      retryCount: config.retryCount ?? defaultRetryCount,
      retryDelay,
      type: "custom"
    });
  }
  exports.custom = custom;
  //# sourceMappingURL=custom.js.map
  return exports;
}